/* Error.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./Error.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { N200 } from '@atlaskit/theme/colors';
var styles = {
  errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
  errorTitle: "_19pku2gc",
  teamErrorText: "_syaz1wmz _19pku2gc"
};
export var ErrorWrapper = function ErrorWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.errorWrapper)
  }, props));
};
export var ErrorTitle = function ErrorTitle(props) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.errorTitle
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text"
  }, props.children));
};
export var TeamErrorText = function TeamErrorText(props) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.teamErrorText)
  }, props.children);
};